import { motion } from "framer-motion";
import {
  Target, MapPin, BrainCircuit, Map, Megaphone, Radio, FileBarChart,
  Globe2, Store, Trophy, TrainFront,
} from "lucide-react";

const SERVICES = [
  { icon: Target, title: "Precision Geofencing", text: "Create location-based advertising zones around physical locations with radii from 100 metres to 1 kilometre." },
  { icon: MapPin, title: "Geo-Targeted Advertising", text: "Reach audiences based on defined geographic areas, from city blocks to entire precincts." },
  { icon: BrainCircuit, title: "Location Intelligence", text: "Understand campaign activity by location with geographic performance breakdowns." },
  { icon: Map, title: "Interactive Campaign Mapping", text: "Visualise campaigns, pins and geofence zones on live interactive maps." },
  { icon: Megaphone, title: "Digital Advertising", text: "Deploy MP4 video, JPG, PNG and GIF campaigns to audiences inside your geofences." },
  { icon: Radio, title: "Live Campaign Analytics", text: "Monitor impressions, reach, engagement and clicks as they happen — no refresh required." },
  { icon: FileBarChart, title: "Campaign Reporting", text: "Generate professional PDF and CSV campaign reports with executive summaries." },
  { icon: Globe2, title: "Multi-Location Campaigns", text: "Run campaigns across multiple cities and locations from one dashboard." },
  { icon: Store, title: "Retail Location Targeting", text: "Target audiences around retail stores and shopping centres." },
  { icon: Trophy, title: "Event & Stadium Targeting", text: "Activate audiences around events, stadiums and venues on match days." },
  { icon: TrainFront, title: "Transport Hub Targeting", text: "Reach commuters around railway stations, taxi ranks, airports and transport hubs." },
];

export default function Services() {
  return (
    <div>
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(8,145,178,0.12),transparent_50%)]" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-24 relative">
          <p className="section-label">Our Services</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl font-bold text-white tracking-tight max-w-3xl">
            A COMPLETE GEOLOCATION <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">ADVERTISING STACK</span>
          </h1>
          <p className="mt-5 text-lg text-slate-400 max-w-2xl">
            Everything you need to plan, launch and measure location-based digital advertising — in one platform.
          </p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => (
            <motion.div key={s.title} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 3) * 0.08 }}
              className="card-surface p-7 hover:border-blue-500/30 hover:-translate-y-0.5 transition-all" data-testid={`service-${i}`}>
              <div className="w-11 h-11 rounded-md bg-blue-600/15 border border-blue-500/25 flex items-center justify-center">
                <s.icon className="w-5 h-5 text-cyan-400" />
              </div>
              <h3 className="mt-5 font-display font-semibold text-white">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
